export default function genererMail() {
  return {
    to: [],
    cc: [],
    cci: [],
    objet: null,
    corps: null,
    replyTo: null,
    piecesJointes: [],
  };
}
